<template>
    <div class="productDetailBox container_box">
      <div v-if="false" style="width: 100%; text-align: center">
        <img src="@/assets/images/product/loading.gif" alt="" />
      </div>
      <div v-else id="xiangqing" class="container">
        <div class="container_box clearfix">
          <div id="contentListTOP">
            <!-- <div class="dataLeft">
              <router-link to="/" class="dataWeizhi">首页</router-link>
              <b class="icon-arrow-right"> &gt; </b>
              <router-link to="/productList" class="dataWeizhi">商品列表</router-link>
              <b class="icon-arrow-right"> &gt; </b>
              <a href="javascript:;" class="dataWeizhi">{{
                productDetail.name
              }}</a>
            </div> -->
            <div class="header">
      开票员订货系统
    </div>
          </div>
          <div class="xq_main">
            <div class="xq_main_top clearfix">
              <div class="DetilLeft">
                <div class="xq_datu">
                  <div @mousemove="spanMove($event)" @mouseleave="spanOut()" class="jqzoom">
                    <img ref="jqzoomImg" v-if="activeImg && activeImg !== ''" :src="activeImg" alt="商品图片" />
                    <img ref="jqzoomImg" v-else src="../assets/images/common/zwtp.png" alt="商品图片" />
                    <span :style="`top: ${spanMoveStyle.top}px;left: ${spanMoveStyle.left}px;`" v-show="spanMoveShow"
                      ref="moveSpan" class="moveSpan"></span>
                  </div>
                </div>
                <div class="product_img_list">
                  <el-carousel :arrow="sliceArrs(
                    productImg(productDetail),
                    5
                  ).length > 1 ? 'hover' : 'never'" class="xiaotuCar" :autoplay="false" trigger="click">
                    <el-carousel-item v-for="(item, index) of sliceArrs(
                      productImg(productDetail),
                      5
                    )" :key="'xsqgItem' + index">
                      <ul class="xiaotu_list clearfix">
                        <li @mousemove="proImgclick(itemc, indexc)" :class="activeImgIndex == indexc ? 'active' : ''"
                          v-for="(itemc, indexc) of item" :key="indexc">
                          <img :src="`${$imgPath}${itemc}`" alt="" />
                        </li>
                      </ul>
                    </el-carousel-item>
                  </el-carousel>
                </div>
                <!-- <div class="shareBox">
                  <span> 分享至：</span>
                  <vshare :vshareConfig="vshareConfig"></vshare>
                </div> -->
              </div>
              <div class="bigPic" ref="bigPic" v-show="bigDivShow">
                <img :style="`top: ${picMoveStyle.top}px;left: ${picMoveStyle.left}px;`" ref="bigPicImg"
                  v-if="bigImg && bigImg !== ''" :src="bigImg" alt="商品图片" />
                <img :style="`top: ${picMoveStyle.top}px;left: ${picMoveStyle.left}px;`" ref="bigPicImg" v-else
                  src="../assets/images/common/zwtp.png" alt="商品图片" />
              </div>
              <div class="mid" style="width:500px">

                <div class="text textBox">
                  <p>
                    <span class="justy">生产厂家：</span>{{ productDetail.manufacturer }}
                  </p>
                  <p>
                    <span class="justy">包装单位：</span>{{ productDetail.unit }}
                  </p>
                  <p v-if="productDetail.mediumPkgSize || productDetail.bigPkgSize">
                    <span class="justy">中/大包装：</span>{{ productDetail.mediumPkgSize }}/{{
                      productDetail.bigPkgSize
                    }}
                  </p>
                  <p>
                    <span class="justy">批准文号：</span>{{
                      productDetail.license
                      ? productDetail.license
                      : "暂无信息"
                    }}
                  </p>
                  <!-- <p>
                    <span class="justy">产品批号：</span>{{
                        inventoryAct.batchNumber
                          ? inventoryAct.batchNumber
                          : (loginState ? "暂无信息" : "会员可见")
                    }}
                  </p> -->
                  <div>
                    <p>
                      <span class="justy">有效期至：</span>{{
                        inventoryAct.endDate
                        ? ` ${renderEndDate(inventoryAct.endDate)}`
                        : (loginState ? "暂无信息" : "会员可见")
                      }}
                    </p>
                  </div>
                </div>
                <div class="format-box">
                    <div class="invoiced-amount">
          <span >开票金额: </span>
          <span style="color:#E60036" >{{ inventoryAct.price }}</span>
        </div>
        <div class="invoiced-amount">
          <span >总金额: </span>
          <span style="color:#E60036" >{{ saleProductMoney}}</span>
        </div>
                </div>
                <div class="inventoryNumBox">
                  <div v-if="productDetail.inventoryList &&
                    productDetail.inventoryList.length > 1
                    " class="selectInventory">
                    <span v-for="(item, index) of productDetail.inventoryList" :key="'inventory' + index"
                      :class="{ selected: selectInventoryIndex == index }" @click="selectInventory(item, index)"
                      class="kuwei">
                      {{ item.inventoryTypeName && item.inventoryTypeName !== '' ? item.inventoryTypeName : index + 1 }}库
                    </span>
                  </div>
                  <div class="inputBox">
                    数量:
                    <input class="amount" v-model="saleProductAmount" @keyup.enter="submitWantBuy" @input="changeSaleAmount($event)" type="text">
                    <!-- <div class="inputNumber fr">
                      <span @click="lessNum(inventoryAct, productDetail)" class="mins"> &minus; </span>
                      <input @change="changeNum(inventoryAct, productDetail, $event)" @focus="selectShopAmount($event)"
                        :class="inventoryAct.shoppingCartAmount &&
                            inventoryAct.shoppingCartAmount > 0
                            ? 'cartHasThis'
                            : ''
                          " :value="inventoryAct.addCartQuantity"
                        @keyup.enter="jionShopCart(inventoryAct, productDetail, $event)"
                        oninput="value=value.replace(/[^0-9.]/g,'')" type="text" class="shopNumber" />
                      <span @click="addNum(inventoryAct, productDetail)" class="plus"> &plus; </span>
                    </div> -->
                    
                  </div>
  
                  <div v-if="productDetail.productActivityPriceStrategyDetail" class="kucunBox act">
                    个人限购：最大
                    {{
                      productDetail.productActivityPriceStrategyDetail
                        .canSaleAmount === 99999999
                      ? "不限购"
                      : productDetail.productActivityPriceStrategyDetail
                        .canSaleAmount
                    }}
                    ，最小
                    {{
                        productDetail.productActivityPriceStrategyDetail
                        .customerBuyMinNum === -1
                      ? "不限购"
                      : productDetail.productActivityPriceStrategyDetail
                        .customerBuyMinNum
                    }}
                  </div>
                  <div class="kucunBox">
                    库存：
                    {{ loginState ? showInventoryText(inventoryAct.inventory, productDetail) : "会员可见" }}
                  </div>
                </div>
                <div class="caozuoBox">
                    <a  @click="submitWantBuy" class="jionBtn" href="javascript:;">保存</a>
                  <!-- <a v-if="(inventoryAct.inventory > 0 || !loginState)"
                    @click="jionShopCart(inventoryAct, productDetail, $event)" href="javascript:;" class="jionBtn">
                    <img src="../assets/images/product/detail/cartIcon.jpg" alt="" />
  
                    {{ (productDetail.offlineSaleFlag && productDetail.offlineSaleFlag == '1') ? '开票员订货' : '加入购物车' }}
                  </a> -->
                </div>
                <!-- <div class="imgTip">
                  温馨提示：产品图片仅供参考，请以实物为准。
                </div> -->
              </div>
            </div>
          </div>
    
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { deleteAction, getAction, postAction } from "@/api/manage";
  import { accAdd } from "@/assets/js/common/common";
  import { getUserInfo } from "../assets/js/common/common";
  import { ProductMixin } from "@/mixins/ProductMixin";
  import { accMuls } from "../assets/js/common/common";
  import { mapGetters } from 'vuex';
  export default {
    name: "ProductDetail",
    mixins: [ProductMixin],
    data() {
      return {
        vshareConfig: {
          shareList: [
            "qzone",
            "tsina",
            "sqq",
            "weixin",
            // 此处放分享列表（ID）
          ],
        },
        productId: "",
        inventoryAct: {},
        productDetail: {},
        loading: false,
        productImgArr: [],
        activeBottom: "detail",
        activeImgIndex: 0,
        activeImg: "",
        bigImg: "",
        shoppingCartAmount: 0,
        tId: "_t1",
        tabProductList: [],
        tabIndex: 0,
        selectedTabList: [],
        hasClick: true,
        haslogin: false,
        floorListData: [],
        companyId: null,
        loginState: false,
        selectInventoryIndex: 0,
        bigDivShow: false, // 大图展示状态
        spanMoveShow: false, // 移动模块展示状态
        saleProductMoney: 0, // 采购产品的总价格
        saleProductAmount: 0,
        picMoveStyle: {
          top: 0,
          left: 0
        },
        spanMoveStyle: {
          top: 0,
          left: 0
        },
        productRecList: [
        ], // 产品推荐代码
      };
    },
    computed: {
      ...mapGetters(['companyConfigData'])
    },
    created() {
      let userInfo = getUserInfo();
      if (userInfo) {
        this.loginState = true;
        this.companyId = userInfo.companyId;
      } else {
        this.loginState = false;
      }
      this.backTop();
      const productId = this.$route.query.productId;
      const liveActivityId = this.$route.query.liveActivityId;
      if (liveActivityId && liveActivityId !== '') {
        this.$alert("直播价格仅限直播间内享受！", "提示信息", {
          type: "error",
        });
      }
      this.productId = productId;
      this.getProductDetail();
      this.getProductRecommend()
      this.tabIndex = 0;
      if (this.tabProductList.legnth > 0) {
        this.selectedTabList = this.tabProductList[0].list;
      }
    },
    methods: {
      // 用户端设置产品输入框步进操作
      setStepValue(value) {
        console.log("value+++++++++++", value)
        let productStep = 1;
        if (typeof (value) === 'string' && value !== '') {
          productStep = JSON.parse(value)
        } else if (typeof (value) === 'number' && value > 1) {
          productStep = value
        }
        // 判断当前选中的规格步进是否大于库存
        let inventory = this.inventoryAct.inventory
        if (productStep > inventory) {
          this.inventoryAct.addCartQuantity = inventory
        } else {
          this.inventoryAct.addCartQuantity = productStep
        }
        console.log("用户当前选择的步进数量为++++++", productStep)
        this.productStep = productStep
      },
      // 获取热搜产品列表数据
      async getProductRecommend() {
        let url = "homeShow/areaProductPush/listById"
        let productId = this.productId
        let data = {
          productId: productId
        }
        let res = await postAction(url, data);
        if (res.code == 200 && res.success) {
          let resData = res.result;
          this.productRecList = this.sliceArrs(resData, 3)[0];
          console.log("获取产品推荐列表数据为", this.productRecList)
        }
      },
      // 产品图片均分数组
      sliceArrs(array, size) {
        var result = [];
        for (var x = 0; x < Math.ceil(array.length / size); x++) {
          var start = x * size;
          var end = start + size;
          result.push(array.slice(start, end));
        }
        return result;
      },
      // 光标选中全选文字
      selectShopAmount(e) {
        e.currentTarget.select();
      },
      // 点击返回顶部方法
      backTop() {
        window.scroll({
          top: 0,
          left: 0,
          behavior: "auto",
        });
      },
      // 显示产品图片
      productImg(item) {
        if (item.picUrl && item.picUrl !== "") {
          let imgsArr = item.picUrl.split(",");
          let imgSrc = imgsArr;
          return imgSrc;
        } else {
          let imgSrc = "";
          return imgSrc;
        }
      },
      // 渲染总库存
      renderAllInventory(productDetail) {
        let inventoryList = productDetail.inventoryList;
        if (inventoryList && inventoryList.length > 0) {
          let allNum = 0;
          for (let key of inventoryList) {
            allNum = accAdd(allNum, key.inventory);
          }
          return allNum;
        } else {
          return "暂无库存";
        }
      },
      // 修改效期数据
      renderEndDate(endDate) {
        return endDate.replace(" 00:00:00", "");
      },
      // 获取产品详情数据
      getProductDetail() {
        const _this = this;
        const productId = this.productId;
        const url = "/product/getProductDetail";
        const data = {
          productId: productId,
        };
        this.loading = true;
        getAction(url, data).then((res) => {
          this.loading = false;
          if (res.code === 200 && res.success) {
            _this.productDetail = res.result;
            if (res.result.picUrl && res.result.picUrl !== "") {
              let productPicUrl = res.result.picUrl.split(",");
              _this.activeImg = `${this.$imgPath}${productPicUrl[0]}`;
              _this.bigImg = `${this.$imgPath}${productPicUrl[0]}`;
            }
            if (res.result.inventoryList && res.result.inventoryList.length > 0) {
              _this.inventoryList = res.result.inventoryList;
              _this.inventoryAct = res.result.inventoryList[0];
              _this.selectInventoryIndex = 0;
              if (_this.inventoryAct.uid) {
                const uidArr = _this.inventoryAct.uid.split(",,");
                const tId = uidArr[uidArr.length - 1];
                _this.tId = tId;
              }
            }
          }
        });
      },
      spanMove(e) {
        let normalPic = this.$refs.jqzoomImg;
        let spanMove = this.$refs.moveSpan;
        let bigDiv = this.$refs.bigPic;
        let picMove = this.$refs.bigPicImg;
        this.bigDivShow = true;
        this.spanMoveShow = true;
        let bigSize = picMove.offsetHeight;
        let littleSize = normalPic.offsetHeight;
        let n = bigSize / littleSize;
        let picX = normalPic.getBoundingClientRect().left;
        let picY = normalPic.getBoundingClientRect().top;
        let mouseX = e.clientX - picX;
        let mouseY = e.clientY - picY;
        let spanW = spanMove.offsetWidth;
        let spanH = spanMove.offsetHeight;
        let normalPicW = normalPic.offsetWidth;
        let normalPicH = normalPic.offsetHeight;
        let bigW = bigDiv.offsetHeight;
        let picMoveLeft = 0;
        let picMoveTop = 0;
        let spanMoveLeft = 0;
        let spanMoveTop = 0;
        if (mouseX <= spanW / 2) {
          picMoveLeft = 0;
          spanMoveLeft = 0;
        } else if (mouseX > spanW / 2 && mouseX < normalPicW - spanW / 2) {
          let tempX = mouseX - spanW / 2;
          picMoveLeft = -n * tempX;
          spanMoveLeft = tempX;
        } else {
          picMoveLeft = -n * (normalPicW - spanW);
          spanMoveLeft = normalPicW - spanW;
        }
        if (mouseY <= spanH / 2) {
          picMoveTop = 0;
          spanMoveTop = 0;
        } else if (mouseY > spanH / 2 && mouseY < normalPicH - spanH / 2) {
          let tempY = mouseY - spanH / 2;
          picMoveTop = -n * tempY;
          spanMoveTop = tempY;
        } else {
          picMoveTop = -(n * normalPicH - bigW);
          spanMoveTop = normalPicH - spanH;
        }
        this.picMoveStyle = {
          top: picMoveTop,
          left: picMoveLeft
        };
        this.spanMoveStyle = {
          top: spanMoveTop,
          left: spanMoveLeft
        }
      },
      spanOut() {
        this.bigDivShow = false;
        this.spanMoveShow = false;
      },
      proImgclick(item, index) {
        this.bigImg = `${this.$imgPath}${item}`;
        this.activeImg = `${this.$imgPath}${item}`;
        this.activeImgIndex = index;
      },
      handleBottomClick(tab, event) { },
      selectInventory(item, index) {
        if (item.uid) {
          const uidArr = item.uid.split(",,");
          const tId = uidArr[uidArr.length - 1];
          this.tId = tId;
        }
        this.selectInventoryIndex = index;
        this.inventoryAct = item;
      },
      qiugouDenglu(item) {
        const productName = item.name;
        const format = item.format;
        const manufacturer = item.manufacturer;
        const productId = item.productId;
        const data = {
          productName: productName,
          format: format,
          manufacturer: manufacturer,
          productId: productId,
        };
        const requirement = this.$router.resolve({
          path: "/requirement",
          query: data,
        });
        window.open(requirement.href, "_blank");
      },
      customerCollect(item, flag) {
        let loginState = this.loginState;
        if (loginState) {
          const _this = this;
          let url = "";
          let data = {};
          if (flag === 1) {
            data = {
              productId: item.productId,
            };
            url = "/customerCollectProduct/customerCollectProduct/add";
            postAction(url, data).then((res) => {
              if (res.code === 200 && res.success) {
                _this.$message({
                  message: "已成功收藏该产品",
                  offset: 400,
                  duration: 1000,
                  type: "success",
                });
                item.isCollect = 1;
  
                _this.$store.commit("COLLECT_UPLOAD_STATUS", true);
              }
            });
          } else {
            data = {
              productId: item.productId,
            };
            url =
              "/customerCollectProduct/customerCollectProduct/cancelProductCollect";
            deleteAction(url, data).then((res) => {
              if (res.code === 200 && res.success) {
                _this.$message({
                  message: "已取消收藏该产品",
                  offset: 400,
                  duration: 1000,
                  type: "info",
                });
                item.isCollect = 0;
                _this.$store.commit("COLLECT_UPLOAD_STATUS", false);
              }
            });
          }
        } else {
          this.$router.push("/login")
        }
      },
        // 修改采购未挂网产品数量
    changeSaleAmount(e) {
      let saleAmout = this.saleProductAmount.replace(/[^0-9]/g, '');
      let inventory = this.inventoryAct.inventory
      if (saleAmout > inventory) {
        saleAmout = inventory
        this.$message({
          offset: 200,
          duration: 1000,
          message: "当前产品最大库存为：" + inventory,
          type: 'error'
        })
      } else if (saleAmout <= 0) {
        saleAmout = 1
      }
      this.saleProductAmount = saleAmout;
      // 触发计算总金额
      this.calculateTotalPrice()
    },
    // 计算采购总金额
    calculateTotalPrice() {
      let amount = this.saleProductAmount;
      let price = this.inventoryAct.price;
      let allMoney = accMuls(price, amount)
      this.saleProductMoney = allMoney
    },
    // 点击保存未挂网产品
    async submitWantBuy() {
      let addPrice = this.inventoryAct.price;
      let amount = this.saleProductAmount;
      let uid = this.inventoryAct.uid;
      let addShopData = {
        addPrice: addPrice,
        amount: amount,
        uid: uid
      };
      let addShopUrl = "/shopping/cart/add?getList=1";
      let res = await postAction(addShopUrl, addShopData);
      if (res.code == 200 && res.success) {
        this.$message({
          message: `商品已添加到购物车！`,
          offset: 400,
          duration: 2000,
          type: 'success'
        })
        this.$router.push('/productList');
        // closeWindow()
      }
    },
    },
  
    watch: {
      $route(to, from) {
        let routerName = to.name;
        if (routerName == "productDetail") {
          const productId = to.query.productId;
          this.productId = productId;
          this.getProductDetail();
          this.getProductRecommend()
          this.$nextTick(() => {
  
            this.shareList = [
              "qzone",
              "tsina",
              "sqq",
              "weixin",
              // 此处放分享列表（ID）
            ]
          })
          return false;
        }
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  @import "../assets/styles/product/productDetail";
  @import "../assets/styles/center/wantToBuyProduct";
  </style>
  